var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParkingPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8 0C8.73075 0 3 5.73075 3 12.8C3 21.5478 10.4667 27.7333 15.8 32C21.1333 27.7333 28.6 21.5478 28.6 12.8C28.6 5.73075 22.8693 0 15.8 0Z",
    fill: "#F34F42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 12.279C21 13.8183 20.6379 15.0486 19.9136 15.97C19.1953 16.8856 18.2267 17.3433 17.0079 17.3433C15.8832 17.3433 14.9823 16.9857 14.3052 16.2704V21H12V7.18884H14.1286L14.2257 8.20172C14.9028 7.40057 15.8214 7 16.9814 7C18.2355 7 19.2188 7.45494 19.9313 8.36481C20.6438 9.26896 21 10.5279 21 12.1416V12.279ZM18.7036 12.0815C18.7036 11.0858 18.4975 10.2961 18.0854 9.71245C17.6791 9.12876 17.0962 8.83691 16.3366 8.83691C15.3945 8.83691 14.7174 9.21459 14.3052 9.96996V14.3991C14.7233 15.1717 15.4063 15.5579 16.3543 15.5579C17.0903 15.5579 17.6644 15.2718 18.0765 14.6996C18.4946 14.1216 18.7036 13.2489 18.7036 12.0815Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkingPin);
export default __webpack_public_path__ + "static/media/parkingPin.dcde500ad4f9d43f504a61168173cdcc.svg";
export { ForwardRef as ReactComponent };